
export const imageUrl = (url: string | undefined, width: number) => `${url}?width=${width}`;
